function isValidPassword(password = '') {
    return password.length >= 6;
}

export default isValidPassword;



// WEBPACK FOOTER //
// ./src/service/isValidPassword.js